<template>
  <component v-if="visible" :is="rootTag" :class="['fd-html', clazz, errorClass]" :style="style" v-html="htmlBody"></component>
</template>

<script setup lang="ts">
import usePart, {type PartProps, partProps} from "../Part";
import {computed} from "vue";
import type {Html} from "@t/fd/fixed/Html";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const html = computed<Html>(() => props.part as Html);
const { visible, valueExpression, clazz, style, errorLevel } = usePart(props);

const htmlBody = valueExpression("value", "ex");

const rootTag = computed(() => {
  return html.value.tag ? html.value.tag : "div";
});

const errorClass = computed(() => {
	const l = errorLevel.value;
	if (l === "SEVERE") return "invalid-text";
	else if (l === "WARNING") return "warn-text";
	else if (l === "INFO") return "info-text";
});

</script>

<style scoped>

</style>
